import appGlobalScript from '/usr/mware/jenkins/workspace/global_promotions/global_promotions_stage/mepa-web-component-frontend/packages/stencil-library/src/globals/global.ts';
export const globalScripts = appGlobalScript;
